import React from "react";
import { IconButton, TextField } from "material-ui";

class QuantityEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: props.quantity
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    let quantity = e.target.value;

    // Ignore non-numeric characters
    if (quantity && quantity != +quantity) {
      return;
    }

    if (typeof quantity !== "undefined") {
      // make whole
      quantity = Math.ceil(quantity);

      if (this.props.max && quantity > this.props.max) {
        quantity = this.props.max;
      } else if (this.props.min && quantity < this.props.min) {
        quantity = this.props.min;
      }
      this.props.updateQuantity(quantity);
    }

    this.setState({ quantity });
  }


  render() {

    const isSundance = this.props.sundance;

    const iconStyle = isSundance
      ? { fontSize: 12, color: this.state.quantity === 1 ? "#ccc" : "#000", width: 24, height: 24 }
      : { fontSize: 12 };

    const textfieldStyle = isSundance
      ? { width: 20, height: 35, paddingLeft: 5, paddingRight: 5, marginLeft: 6, marginRight: 0, border: "1px solid gray" }
      : { width: 20 };

    return (
      <div style={this.props.style}>
        <IconButton
          iconStyle={iconStyle}
          iconClassName="icon-minus"
          onClick={() =>
            this.onChange({ target: { value: this.state.quantity - 1 } })
          }
          disabled={isSundance ? false :
            this.state.quantity === this.props.min || this.props.max === 0
          }
        />
        <TextField
          name="quantity"
          value={this.state.quantity}
          onChange={this.onChange}
          underlineShow={false}
          style={textfieldStyle}
          disabled={this.props.max === 0}
        />
        <IconButton
          iconStyle={{ fontSize: 12 }}
          iconClassName="icon-plus"
          onClick={() =>
            this.onChange({ target: { value: this.state.quantity + 1 } })
          }
          disabled={this.state.quantity === this.props.max}
        />
      </div>
    );
  }
}

export default QuantityEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/quantity-editor.jsx